import {List as ImmutableList} from 'immutable';

export default class ImmutableQueue {
  constructor(sequence = ImmutableList()) {
    let immutableList;

    if (Array.isArray(sequence)) {
      immutableList = sequence;
    } else {
      immutableList = ImmutableList(sequence);
    }

    this._list = immutableList;
    this.size = immutableList.size;
  }

  enqueue(value) {
    return new ImmutableQueue(this._list.unshift(value));
  }

  dequeue() {
    return new ImmutableQueue(this._list.pop());
  }

  last() {
    return this._list.last();
  }
}
